
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    chatTitle: 'Write to support',
    chatHint: 'We answer in the chat here — attach a screenshot if it helps.',
    chatAction: 'Open chat',
    title: 'Support',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Working hours',
    labelResponse: 'Response time',
    valueHours: '12:00–18:00 on business days',
    valueResponse: '24 hours',
  },
  ru: {
    chatTitle: 'Написать в поддержку',
    chatHint: 'Ответим прямо здесь, в чате. Можешь приложить скриншот.',
    chatAction: 'Открыть чат',
    title: 'Поддержка',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Часы работы',
    labelResponse: 'Срок ответа',
    valueHours: '12–18 ежедневно по рабочим дням',
    valueResponse: '24 часа',
  },
  uz: {
    chatTitle: 'Qoʻllab-quvvatlashga yozish',
    chatHint: 'Shu yerda, chatda javob beramiz. Skrinshot ilova qilishing mumkin.',
    chatAction: 'Chatni ochish',
    title: 'Qoʻllab-quvvatlash',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Ish vaqti',
    labelResponse: 'Javob muddati',
    valueHours: 'Ish kunlari 12:00–18:00',
    valueResponse: '24 soat',
  },
  fa: {
    chatTitle: 'به پشتیبانی بنویس',
    chatHint: 'همین‌جا در چت جواب می‌دهیم — اگر کمک می‌کند، اسکرین‌شات بفرست.',
    chatAction: 'باز کردن چت',
    title: 'پشتیبانی',
    labelEmail: 'ایمیل',
    labelTelegram: 'تلگرام',
    labelHours: 'ساعت کاری',
    labelResponse: 'زمان پاسخ',
    valueHours: '12:00–18:00 روزهای کاری',
    valueResponse: '24 ساعت',
  },
  pt: {
    chatTitle: 'Escrever para o suporte',
    chatHint: 'Respondemos aqui mesmo, no chat. Pode anexar um print.',
    chatAction: 'Abrir chat',
    title: 'Suporte',
    labelEmail: 'E-mail',
    labelTelegram: 'Telegram',
    labelHours: 'Horário de atendimento',
    labelResponse: 'Tempo de resposta',
    valueHours: '12:00–18:00 em dias úteis',
    valueResponse: '24 horas',
  },
  tr: {
    chatTitle: 'Desteğe yaz',
    chatHint: 'Burada, sohbette cevaplıyoruz. Ekran görüntüsü de ekleyebilirsin.',
    chatAction: 'Sohbeti aç',
    title: 'Destek',
    labelEmail: 'E-posta',
    labelTelegram: 'Telegram',
    labelHours: 'Çalışma saatleri',
    labelResponse: 'Yanıt süresi',
    valueHours: 'İş günlerinde 12:00–18:00',
    valueResponse: '24 saat',
  },
});
